// BrandMonogramEdge — the Xaluca "X" monogram (Borde variant) anchored
// flush to the bottom-right corner of any container, designed to read as
// part of the container's border construction rather than an overlay
// graphic.
//
// Drop it into any element marked `relative overflow-hidden` (page heroes,
// video placeholders, editorial cards) to give it the same intentional,
// site-wide brand watermark.

import React from "react";

const MARK_URL =
  "https://customer-assets.emergentagent.com/job_c24999ff-c14f-412e-baf4-b11c0020fcc2/artifacts/22pm8drk_Monograma%20X%20Borde.png";

// Height as a percentage of the parent — scales naturally with the
// container's aspect ratio across desktop, tablet and mobile.
const SIZE_CLASS = {
  sm: "h-[60%] sm:h-[70%]",
  md: "h-[68%] sm:h-[78%]",
  lg: "h-[78%] sm:h-[88%]",
  xl: "h-[82%] sm:h-[90%]",
};

const BrandMonogramEdge = ({
  size = "lg",
  opacity = 0.55,
  testIdPrefix = "brand-monogram-edge",
}) => {
  const sz = SIZE_CLASS[size] || SIZE_CLASS.lg;

  return (
    <img
      src={MARK_URL}
      alt=""
      aria-hidden="true"
      className={`absolute right-0 bottom-0 w-auto ${sz} object-contain pointer-events-none select-none z-[3]`}
      style={{
        opacity,
        filter: "drop-shadow(0 2px 10px rgba(26,21,19,0.35)) brightness(1.05)",
      }}
      data-testid={`${testIdPrefix}-monogram`}
      data-no-cms-edit="true"
      data-no-xaluca-logo="true" loading="lazy" decoding="async"/>
  );
};

export default BrandMonogramEdge;
